/*
 * TableContainer
 *
 * A container for table which enable the table scrolled horizontally.
 */

import { HTMLAttributes, PropsWithChildren, useEffect, useRef } from "react";
import classNames from "classnames";

import { StyledTableContainer } from "./TableContainer.styled";

function TableContainer(props: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  const ref = useRef<HTMLDivElement>();
  const { children, className, ...restProps } = props;
  const tableContainerClass = classNames("c-table-container", className);

  useEffect(() => {
    // Ensure the scroll always at the bottom (Assuming that the Table component in this child has reverted children, which causes the bottom point to be reverted too)
    ref.current.scrollTo(0, ref.current.scrollHeight);
  }, []);

  return (
    <StyledTableContainer ref={ref} className={tableContainerClass} {...restProps}>
      {children}
    </StyledTableContainer>
  );
}

export default TableContainer;
